(() => {
	if (window.karofiLuxury) return;
	window.karofiLuxury = true;

	// First-touch attribution, kept 30 days in cookies (same k_ names as the payday lead form).
	const TRACK_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ttclid'];
	const readCookie = (n) => {
		const m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)');
		return m ? decodeURIComponent(m.pop()) : '';
	};
	const writeCookie = (n, v) => {
		document.cookie = n + '=' + encodeURIComponent(v) + ';path=/;max-age=' + 60 * 60 * 24 * 30 + ';SameSite=Lax';
	};
	try {
		const q = new URLSearchParams(window.location.search);
		TRACK_KEYS.forEach((k) => { const v = q.get(k); if (v) writeCookie('k_' + k, v); });
		if (document.referrer && document.referrer.indexOf(window.location.host) === -1 && !readCookie('k_referrer')) writeCookie('k_referrer', document.referrer);
		if (!readCookie('k_landing')) writeCookie('k_landing', window.location.href.split('#')[0]);
	} catch (e) {}
	window.karofiTracking = () => {
		const q = new URLSearchParams(window.location.search);
		const t = {};
		TRACK_KEYS.forEach((k) => { t[k] = q.get(k) || readCookie('k_' + k) || ''; });
		t.landing_page = readCookie('k_landing') || window.location.href;
		t.page_url = window.location.href.split('#')[0];
		t.referrer = readCookie('k_referrer') || 'direct';
		t.user_agent = navigator.userAgent;
		t.fbp = readCookie('_fbp');
		t.fbc = readCookie('_fbc');
		return t;
	};

	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	const root = document.documentElement;

	const countUp = (el) => {
		const target = parseFloat(el.dataset.countTo);
		if (Number.isNaN(target) || reduceMotion) return;
		const decimals = (el.dataset.countTo.split('.')[1] || '').length;
		const duration = 2200;
		const start = performance.now();
		const tick = (now) => {
			const t = Math.min((now - start) / duration, 1);
			const eased = 1 - Math.pow(1 - t, 3);
			const v = (target * eased).toFixed(decimals);
			el.textContent = el.dataset.countFormat === 'comma' ? Number(v).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) : v;
			if (t < 1) requestAnimationFrame(tick);
		};
		requestAnimationFrame(tick);
	};

	// Letters shuffle, then settle one by one into the final word (e.g. "NSF").
	const scramble = (el) => {
		const final = el.textContent;
		if (reduceMotion || !final.trim()) return;
		const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
		let frame = 0;
		const total = 26;
		const tick = () => {
			frame += 1;
			const settled = Math.floor((frame / total) * final.length);
			el.textContent = final.split('').map((c, i) => (i < settled || c === ' ' ? c : chars[Math.floor(Math.random() * chars.length)])).join('');
			if (frame < total) setTimeout(tick, 45);
			else el.textContent = final;
		};
		tick();
	};

	const init = () => {
		const items = document.querySelectorAll('.lux [data-reveal]');
		const counters = document.querySelectorAll('.lux [data-count-to]');
		if (!('IntersectionObserver' in window) || reduceMotion) return;

		root.classList.add('lux-anim');

		// Stagger siblings that share the same parent.
		items.forEach((el) => {
			const siblings = Array.from(el.parentElement.children).filter((c) => c.hasAttribute('data-reveal'));
			el.style.setProperty('--lux-delay', `${Math.min(siblings.indexOf(el), 6) * 90}ms`);
		});

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					entry.target.classList.add('is-revealed');
					entry.target.querySelectorAll('[data-count-to]').forEach(countUp);
					entry.target.querySelectorAll('[data-scramble]').forEach(scramble);
					if (entry.target.hasAttribute('data-count-to')) countUp(entry.target);
					observer.unobserve(entry.target);
				});
			},
			{ rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
		);
		items.forEach((el) => observer.observe(el));
		// Safety net: reveal anything already scrolled past (e.g. elements flattened by a transform
		// that the observer cannot see).
		let ticking = false;
		const sweep = () => {
			ticking = false;
			const limit = window.innerHeight * 0.92;
			items.forEach((el) => {
				if (el.classList.contains('is-revealed')) return;
				const top = el.getBoundingClientRect().top;
				if (top < limit) {
					el.classList.add('is-revealed');
					el.querySelectorAll('[data-count-to]').forEach(countUp);
					el.querySelectorAll('[data-scramble]').forEach(scramble);
					if (el.hasAttribute('data-count-to')) countUp(el);
				}
			});
		};
		window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }, { passive: true });
		setTimeout(sweep, 1500);
		counters.forEach((el) => {
			if (!el.closest('[data-reveal]')) observer.observe(el);
		});
	};

	// Lead forms: any <form data-lead-form="Name"> fires the Pixel event and, when the market
	// lead webhook is set (theme setting lead_webhook_url), posts a JSON payload to it with the
	// same event_id, then continues its normal Shopify submission. Without a webhook the form
	// is a standard Shopify form and the store receives it by email.
	const toKey = (name) => {
		const m = name.match(/^(?:contact|customer)\[(.+)\]$/);
		return (m ? m[1] : name).trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
	};
	const normalizePhone = (raw) => {
		// Indonesian mobile numbers: 08xx / 628xx / +62 8xx, 9 to 12 digits after the country code.
		let d = (raw || '').replace(/[^0-9]/g, '');
		if (d.startsWith('62')) d = d.slice(2);
		if (d.startsWith('0')) d = d.slice(1);
		return d.startsWith('8') && d.length >= 9 && d.length <= 12 ? '+62' + d : (raw || '').trim();
	};
	const leadPayload = (form) => {
		const data = {};
		new FormData(form).forEach((value, name) => {
			if (['form_type', 'utf8', 'authenticity_token', 'g-recaptcha-response'].includes(name) || typeof value !== 'string') return;
			const key = toKey(name);
			data[key] = data[key] ? data[key] + '; ' + value.trim() : value.trim();
		});
		const phone = data.mobile || data.phone || data.mobile_number || '';
		const eventId = 'lead_' + Date.now() + '_' + Math.floor(Math.random() * 1e6);
		const modelField = form.dataset.leadModelField ? data[toKey(form.dataset.leadModelField)] : '';
		return Object.assign({}, data, {
			form: form.dataset.leadForm,
			campaign: form.dataset.leadCampaign || toKey(form.dataset.leadForm),
			full_name: data.name || data.full_name || [data.first_name, data.last_name].filter(Boolean).join(' '),
			phone: normalizePhone(phone),
			email: data.email || '',
			model: [form.dataset.leadModel, modelField || data.product || data.topic].filter(Boolean).join(' - ') || form.dataset.leadForm,
			message: data.body || data.message || '',
			event_id: eventId,
			submitted_at: new Date().toISOString()
		}, window.karofiTracking ? window.karofiTracking() : {});
	};
	const LEAD_HOTLINE = '+62 811-8802-8669';
	const trackLead = (form, payload) => {
		const pixelEvent = form.dataset.leadPixel || 'Lead';
		if (window.fbq && pixelEvent !== 'none') {
			window.fbq('track', pixelEvent, { content_name: payload.model, content_category: payload.form, currency: 'IDR', value: 1000 }, { eventID: payload.event_id });
		}
		if (window.dataLayer) window.dataLayer.push({ event: 'karofi_lead_submit', form: payload.form, model: payload.model });
	};
	const initLeadForms = () => {
		document.querySelectorAll('form[data-lead-form]').forEach((form) => {
			if (form.dataset.leadReady) return;
			form.dataset.leadReady = 'true';
			let sent = false;
			form.addEventListener('submit', (e) => {
				const endpoint = form.dataset.webhook || window.karofiLeadWebhook;
				if (form.dataset.leadOnly === 'true' && !endpoint) {
					e.preventDefault();
					window.alert('Sorry, we could not send your message. Please call or WhatsApp ' + LEAD_HOTLINE + '.');
					return;
				}
				if (sent || !form.checkValidity()) return;
				if (!endpoint) {
					// Standard Shopify form: track, then let the browser submit it as usual.
					sent = true;
					trackLead(form, leadPayload(form));
					return;
				}
				e.preventDefault();
				const payload = leadPayload(form);
				const button = form.querySelector('[type="submit"]');
				if (button) { button.disabled = true; button.dataset.label = button.textContent; button.textContent = 'Sending...'; }
				trackLead(form, payload);
				// Lead-only forms (contact page) go to the webhook only:
				// no Shopify contact email, no Shopify captcha.
				if (form.dataset.leadOnly === 'true') {
					const done = (ok) => {
						if (!ok) {
							if (button) { button.disabled = false; button.textContent = button.dataset.label; }
							let err = form.querySelector('[data-lead-error]');
							if (!err) {
								err = document.createElement('p');
								err.dataset.leadError = '';
								err.className = 'wt-form__error form-notification error';
								form.prepend(err);
							}
							err.textContent = 'Sorry, we could not send your message. Please try again or call / WhatsApp ' + LEAD_HOTLINE + '.';
							return;
						}
						sent = true;
						const thanks = form.dataset.thankYou;
						if (thanks) {
							window.location.href = thanks + (thanks.includes('?') ? '&' : '?') + 'form=' + encodeURIComponent(payload.campaign);
							return;
						}
						const box = document.createElement('div');
						box.className = form.dataset.leadSuccessClass || 'wt-form__success';
						box.setAttribute('role', 'status');
						box.tabIndex = -1;
						const title = document.createElement('strong');
						title.textContent = form.dataset.leadSuccessTitle || 'Terima kasih! We received your message.';
						const text = document.createElement('span');
						text.textContent = form.dataset.leadSuccess || 'Our team will get back to you soon.';
						box.append(title, ' ', text);
						form.replaceChildren(box);
						box.focus();
					};
					const ctrl = window.AbortController ? new AbortController() : null;
					const timer = setTimeout(() => ctrl && ctrl.abort(), 15000);
					fetch(endpoint, {
						method: 'POST',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify(payload),
						signal: ctrl ? ctrl.signal : undefined
					}).then((r) => done(r.ok)).catch(() => done(false)).finally(() => clearTimeout(timer));
					return;
				}
				// Other forms (newsletter) still post to Shopify. Resubmit through
				// requestSubmit so Shopify's submit handlers (captcha token) run.
				const proceed = () => {
					if (sent) return;
					sent = true;
					if (button) { button.disabled = false; button.textContent = button.dataset.label; }
					if (typeof form.requestSubmit === 'function') {
						form.requestSubmit(button || undefined);
					} else {
						HTMLFormElement.prototype.submit.call(form);
					}
				};
				const timer = setTimeout(proceed, 4000);
				fetch(endpoint, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify(payload),
					keepalive: true
				}).catch(() => {}).finally(() => { clearTimeout(timer); proceed(); });
			});
		});
	};

	// Network map: hover a row to highlight its pin; click a pin or row to zoom in
	// and fan out one dot per store in that city.

	// World map: measure each link, draw them when the map scrolls into view,
	// then keep dashes flowing and send a glowing comet along every route.
	const initWorld = () => {
		const svgNS = 'http://www.w3.org/2000/svg';
		document.querySelectorAll('.lux-world').forEach((world) => {
			if (world.dataset.worldReady) return;
			world.dataset.worldReady = 'true';
			const arcs = Array.from(world.querySelectorAll('.wm-arc'));
			arcs.forEach((arc) => {
				try { arc.style.setProperty('--len', Math.ceil(arc.getTotalLength()) + 1); } catch (e) {}
			});
			if (reduceMotion || !('IntersectionObserver' in window)) return;
			const launch = () => {
				world.classList.add('is-drawn');
				const drawTime = 1400 + arcs.length * 70;
				setTimeout(() => {
					world.classList.add('is-flowing');
					const layer = arcs[0] && arcs[0].parentNode;
					if (!layer) return;
					arcs.forEach((arc, i) => {
						const comet = document.createElementNS(svgNS, 'circle');
						comet.setAttribute('r', arc.classList.contains('wm-arc--ph') ? 2.6 : 1.8);
						comet.setAttribute('class', 'wm-comet' + (arc.classList.contains('wm-arc--ph') ? ' wm-comet--ph' : ''));
						const motion = document.createElementNS(svgNS, 'animateMotion');
						const len = parseFloat(arc.style.getPropertyValue('--len')) || 300;
						motion.setAttribute('dur', `${Math.max(1.6, len / 160).toFixed(2)}s`);
						motion.setAttribute('begin', `${(i % 11) * 0.35}s`);
						motion.setAttribute('repeatCount', 'indefinite');
						motion.setAttribute('path', arc.getAttribute('d'));
						comet.appendChild(motion);
						layer.appendChild(comet);
						if (motion.beginElement) { try { motion.beginElement(); } catch (e) {} }
					});
				}, drawTime);
			};
			const io = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					io.disconnect();
					launch();
				});
			}, { threshold: 0.3 });
			io.observe(world);
		});
	};


	// Reviews carousel: arrows jump card by card, mouse drag scrolls the track.
	const initReviews = () => {
		document.querySelectorAll('.lux-reviews__track').forEach((track) => {
			if (track.dataset.revReady) return;
			track.dataset.revReady = 'true';
			const root = track.closest('section') || document;
			const cards = () => Array.from(track.querySelectorAll('.lux-review'));
			const current = () => {
				const left = track.scrollLeft;
				let index = 0;
				cards().forEach((card, i) => { if (card.offsetLeft - track.offsetLeft <= left + 4) index = i; });
				return index;
			};
			const go = (dir) => {
				const list = cards();
				if (!list.length) return;
				const max = track.scrollWidth - track.clientWidth;
				let next = Math.min(Math.max(current() + dir, 0), list.length - 1);
				let target = list[next].offsetLeft - list[0].offsetLeft;
				if (dir > 0 && track.scrollLeft >= max - 4) target = 0;
				else if (dir < 0 && track.scrollLeft <= 4) target = max;
				track.scrollTo({ left: Math.min(target, max), behavior: 'smooth' });
			};
			root.querySelectorAll('.lux-reviews__arrow').forEach((btn) => {
				btn.addEventListener('click', (e) => {
					e.preventDefault();
					go(Number(btn.dataset.dir) || 1);
				});
			});
			let startX = 0;
			let startLeft = 0;
			let dragging = false;
			let moved = false;
			track.addEventListener('pointerdown', (e) => {
				if (e.pointerType !== 'mouse') return;
				dragging = true;
				moved = false;
				startX = e.clientX;
				startLeft = track.scrollLeft;
				track.classList.add('is-dragging');
			});
			window.addEventListener('pointermove', (e) => {
				if (!dragging) return;
				const dx = e.clientX - startX;
				if (Math.abs(dx) > 4) moved = true;
				track.scrollLeft = startLeft - dx;
			});
			window.addEventListener('pointerup', () => {
				if (!dragging) return;
				dragging = false;
				track.classList.remove('is-dragging');
			});
			track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
			track.addEventListener('dragstart', (e) => e.preventDefault());

			// Autoplay: one card every 5 s; pauses on hover, touch, focus, drag or when off screen,
			// and stops for good with the pause button (WCAG 2.2.2).
			if (!reduceMotion) {
				const delay = Number(track.dataset.autoplay || 5000);
				let paused = false;
				let userPaused = false;
				let visible = false;
				setInterval(() => {
					if (!paused && !userPaused && visible && !dragging && !document.hidden) go(1);
				}, delay);
				const nav = root.querySelector('.lux-reviews__nav');
				if (nav) {
					const toggle = document.createElement('button');
					toggle.type = 'button';
					toggle.className = 'lux-reviews__arrow lux-reviews__pause';
					const render = () => {
						toggle.setAttribute('aria-label', userPaused ? 'Play reviews' : 'Pause reviews');
						toggle.setAttribute('aria-pressed', String(userPaused));
						toggle.innerHTML = userPaused
							? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5L8 5.5Z" fill="currentColor"/></svg>'
							: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5h3v14H8zM13 5h3v14h-3z" fill="currentColor"/></svg>';
					};
					toggle.addEventListener('click', () => { userPaused = !userPaused; render(); });
					render();
					nav.insertBefore(toggle, nav.lastElementChild);
				}
				const section = track.closest('section') || track;
				section.addEventListener('mouseenter', () => { paused = true; });
				section.addEventListener('mouseleave', () => { paused = false; });
				section.addEventListener('focusin', () => { paused = true; });
				section.addEventListener('focusout', () => { paused = false; });
				let resume;
				track.addEventListener('touchstart', () => { paused = true; clearTimeout(resume); }, { passive: true });
				track.addEventListener('touchend', () => { clearTimeout(resume); resume = setTimeout(() => { paused = false; }, 4000); }, { passive: true });
				if ('IntersectionObserver' in window) {
					new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; }, { threshold: 0.3 }).observe(track);
				} else {
					visible = true;
				}
			}
		});
	};

	const initMap = () => {
		document.querySelectorAll('.lux-map').forEach((map) => {
			if (map.dataset.luxReady) return;
			map.dataset.luxReady = 'true';
			const canvas = map.querySelector('.lux-map__canvas');
			const layer = map.querySelector('.lux-map__layer');
			const cluster = map.querySelector('.lux-map__cluster');
			const back = map.querySelector('.lux-map__back');
			const panel = map.querySelector('.lux-map__panel');
			if (!canvas || !layer) return;

			const pinFor = (city) => map.querySelector(`.lux-map__pin[data-city="${CSS.escape(city)}"]`);
			const directions = (q) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(q)}`;

			const zoomOut = () => {
				canvas.classList.remove('is-zoomed');
				layer.style.transform = '';
				cluster.innerHTML = '';
				back.hidden = true;
				panel.hidden = true;
				map.querySelectorAll('.lux-map__pin.is-selected, .lux-map__row.is-selected').forEach((el) => el.classList.remove('is-selected'));
			};

			const zoomTo = (pin) => {
				const stores = JSON.parse(pin.dataset.stores || '[]');
				const w = canvas.clientWidth;
				const h = canvas.clientHeight;
				const scale = 2.6;
				const cy = h * 0.34;
				const px = (parseFloat(pin.dataset.x) / 100) * w;
				const py = (parseFloat(pin.dataset.y) / 100) * h;
				layer.style.transform = `translate(${w / 2 - px * scale}px, ${cy - py * scale}px) scale(${scale})`;
				canvas.classList.add('is-zoomed');
				map.querySelectorAll('.lux-map__pin, .lux-map__row').forEach((el) => el.classList.remove('is-selected'));
				pin.classList.add('is-selected');
				const row = map.querySelector(`.lux-map__row[data-city="${CSS.escape(pin.dataset.city)}"]`);
				if (row) row.classList.add('is-selected');

				// Fan the stores out on one or two rings around the city centre.
				cluster.innerHTML = '';
				const inner = Math.min(stores.length, 7);
				stores.forEach((store, i) => {
					const ring = i < inner ? 0 : 1;
					const count = ring === 0 ? inner : stores.length - inner;
					const index = ring === 0 ? i : i - inner;
					const radius = Math.min(w, h) * (ring === 0 ? 0.14 : 0.24);
					const angle = (index / count) * Math.PI * 2 - Math.PI / 2 + ring * 0.4;
					const dot = document.createElement('a');
					dot.className = 'lux-map__store';
					dot.href = directions(store.q);
					dot.target = '_blank';
					dot.rel = 'noopener';
					dot.style.left = `${w / 2 + Math.cos(angle) * radius}px`;
					dot.style.top = `${cy + Math.sin(angle) * radius}px`;
					dot.style.setProperty('--lux-delay', `${i * 45}ms`);
					dot.innerHTML = `<span class="lux-map__store-dot"></span><span class="lux-map__tip"></span>`;
					dot.querySelector('.lux-map__tip').textContent = store.n;
					dot.dataset.index = i;
					cluster.appendChild(dot);
				});

				panel.querySelector('.lux-map__panel-title').textContent = `${pin.dataset.city} · ${stores.length} location${stores.length > 1 ? 's' : ''}`;
				const list = panel.querySelector('.lux-map__panel-list');
				list.innerHTML = '';
				stores.forEach((store, i) => {
					const li = document.createElement('li');
					const name = document.createElement('span');
					name.textContent = store.n;
					const link = document.createElement('a');
					link.href = directions(store.q);
					link.target = '_blank';
					link.rel = 'noopener';
					link.textContent = 'Directions';
					li.append(name, link);
					const dot = cluster.querySelector(`[data-index="${i}"]`);
					li.addEventListener('mouseenter', () => dot && dot.classList.add('is-active'));
					li.addEventListener('mouseleave', () => dot && dot.classList.remove('is-active'));
					list.appendChild(li);
				});
				back.hidden = false;
				panel.hidden = false;
				requestAnimationFrame(() => cluster.classList.add('is-open'));
			};

			map.querySelectorAll('.lux-map__pin').forEach((pin) => {
				pin.querySelector('.lux-map__hit')?.addEventListener('click', () => {
					cluster.classList.remove('is-open');
					zoomTo(pin);
				});
			});
			map.querySelectorAll('.lux-map__row').forEach((row) => {
				const pin = pinFor(row.dataset.city);
				if (!pin) return;
				row.addEventListener('mouseenter', () => pin.classList.add('is-active'));
				row.addEventListener('mouseleave', () => pin.classList.remove('is-active'));
				const open = () => {
					cluster.classList.remove('is-open');
					zoomTo(pin);
					if (window.matchMedia('(max-width: 989px)').matches) canvas.scrollIntoView({ behavior: 'smooth', block: 'center' });
				};
				row.addEventListener('click', open);
				row.addEventListener('keydown', (e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						open();
					}
				});
			});
			back.addEventListener('click', zoomOut);
		});
	};

	// Scale the background map so its zoom-11 extent matches the canvas.
	const fitBasemaps = () => {
		document.querySelectorAll('.lux-map__canvas').forEach((canvas) => {
			const mapW = parseFloat(getComputedStyle(canvas).getPropertyValue('--lux-map-w'));
			if (!mapW) return;
			const apply = () => canvas.style.setProperty('--lux-map-scale', canvas.clientWidth / mapW);
			apply();
			if ('ResizeObserver' in window) new ResizeObserver(apply).observe(canvas);
		});
	};

	// Products mega menu: hovering a category shows its products.
	const initNavTabs = () => {
		document.querySelectorAll('.kn-tabs').forEach((tabs) => {
			if (tabs.dataset.knReady) return;
			tabs.dataset.knReady = 'true';
			const links = tabs.querySelectorAll('[data-kn-tab]');
			const show = (key) => {
				links.forEach((l) => l.classList.toggle('is-active', l.dataset.knTab === key));
				tabs.querySelectorAll('[data-kn-panel]').forEach((panel) => {
					const active = panel.dataset.knPanel === key;
					panel.hidden = !active;
					panel.classList.toggle('is-active', active);
				});
			};
			links.forEach((link) => {
				link.addEventListener('mouseenter', () => show(link.dataset.knTab));
				link.addEventListener('focus', () => show(link.dataset.knTab));
			});
		});
	};

	const start = () => {
		initLeadForms();
		initNavTabs();
		init();
		initMap();
		initWorld();
		initReviews();
		fitBasemaps();
	};
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', start);
	} else {
		start();
	}
	document.addEventListener('shopify:section:load', start);
})();

// Close the header country dropdown when clicking elsewhere.
document.addEventListener('click', (e) => {
	document.querySelectorAll('.kn-country-drop[open]').forEach((d) => {
		if (!d.contains(e.target)) d.removeAttribute('open');
	});
});
